// 全局常量文件

export const common = {
  sdkVersion: "1.0.0",
  signType: "md5",
};

// 日本 战地无疆
export const tkingdomsjp = {
  name: "tkingdomsjp",
  area: "jp",
  email: "game.senran.jp@rastar.com",
  // activityLabel: "27FbIwn6gtqg8kdbePnt",
  // 服务器时间
  serverTime: "",
  // 服务器时间与客户端时间 差值
  differenceTime: "",
  // 初始化key，header头保持使用这个
  initKey: "Rrssz4fZuoANo9xPawytk6xduUeWTcd7",
  aesKey: "EtKwpGbpjinPujNpCE2z3DXlYBoZbqDN",
  // 初始化接口返回key，真实接口使用
  appKey: "",
  // 公钥
  publickey: "",
  // 私钥
  privateKey: "",
};

// 日本冒险岛
export const msrjp = {
  name: "msrjp",
  area: "jp",
  email: "maplestoryr.jp@gmail.com",
  // activityLabel: "27FbIwn6gtqg8kdbePnt",
  // 服务器时间
  serverTime: "",
  // 服务器时间与客户端时间 差值
  differenceTime: "",
  // 初始化key，header头保持使用这个
  initKey: "Rrssz4fZuoANo9xPawytk6xduUeWTcd7",
  aesKey: "EtKwpGbpjinPujNpCE2z3DXlYBoZbqDN",
  // 初始化接口返回key，真实接口使用
  appKey: "",
  // 公钥
  publickey: "",
  // 私钥
  privateKey: "",
};

// 预创盟页面的活动标签不一样，需要做判断
if (window.location.href.indexOf("/treasure") !== -1) {
  if (tkingdomsjp.name == "tkingdomsjp") {
    // 寻宝活动
    tkingdomsjp.activityLabel = "HRkq0vtuvc5cKXeMaG1a";
  } else if (msrjp.name == "msrjp") {
    // 寻宝活动
    msrjp.activityLabel = "KWHHJ80Lcg0PjDIwrMBB";
  }
} else if (window.location.href.indexOf("/challenge") !== -1) {
  if (tkingdomsjp.name == "tkingdomsjp") {
    // 预创盟活动
    tkingdomsjp.activityLabel = "HRkq0vtuvc5cKXeMaG1a";
  }
} else {
  if (tkingdomsjp.name == "tkingdomsjp") {
    // 预约活动
    tkingdomsjp.activityLabel = "rAX0LwNRhqOxzCYrV4gk";
  } else if (msrjp.name == "msrjp") {
    // 预约活动
    msrjp.activityLabel = "27FbIwn6gtqg8kdbePnt";
  }
}

export const projectType = () => {
  if (process.env.VITE_APP_ID === "tkingdomsjp") {
    return tkingdomsjp;
  } else if (process.env.VITE_APP_ID === "msrjp") {
    return msrjp;
  }
};
